import type { ApiRequest } from '@/types/api';
import type {
    RoleAddRequest,
    RoleDetailsRequest,
    RolesRequest,
    RoleUpdateRequest,
} from '@/types/api/roles';

export type RoleDeleteRequest = ApiRequest<'DELETE', `roles/${string}`>;

type RolesApi = {
    list: RolesRequest['url'];
    details(id: string): RoleDetailsRequest['url'];
    update: (id: string) => RoleUpdateRequest['url'];
    add: RoleAddRequest['url'];
    delete: (id: string) => RoleDeleteRequest['url'];
};

export const rolesApi: RolesApi = {
    list: 'roles',
    details: (id: string) => `roles/${id}`,
    update: (id: string) => `roles/${id}`,
    add: 'roles',
    delete: (id: string) => `roles/${id}`,
};
